<template>
  <div class="hideTotal">
    <table-search
      label-width="65px"
      @search="fetchGoodsData(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item label="日期">
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select v-model="query.companyId">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <inquery-result isTips @export="exportExcel('RECEIPT')" />
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="memberNumber"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="dealNumber"
        label="成交号"
      />
      <el-table-column
        fixed
        prop="dealDate"
        label="成交日期"
      >
        <template slot-scope="scope">
          {{ dayJs(scope.row.dealDate).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="bizDate"
        label="业务日期"
      >
        <template slot-scope="scope">
          {{ dayJs(scope.row.bizDate).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <af-table-column
        prop="protocolNumber"
        label="协议书编号"
      />
      <af-table-column
        prop="dealPrice"
        label="成交价"
      />
      <af-table-column
        prop="purQty"
        width="180"
        label="采购约定单量（笔）"
      />
      <el-table-column
        prop="purQty"
        width="180"
        label="采购订单总价"
      >
        <template slot-scope="scope">
          {{ scope.row.purQty * scope.row.dealPrice }}
        </template>
      </el-table-column>
      <af-table-column
        prop="saleQty"
        label="销售约定单量"
      />
      <el-table-column
        prop="bizDate"
        width="180"
        label="销售约定总价"
      >
        <template slot-scope="scope">
          {{ scope.row.saleQty * scope.row.dealPrice }}
        </template>
      </el-table-column>
      <af-table-column
        prop="companyName"
        label="成交方"
      />
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
import dayJs from 'dayjs'
import mixin from '@/utils/mixinFile'
import {
  getFirstDayOfCurrentMonth
} from '@/utils/util.js'

function Query () {
  // earlySettlement 提前 20 到期10
  this.earlySettlement = '10'
  this.endDate = ''
  this.beginDate = ''
  this.companyId = 'hCsAAAAAAYDM567U'
  this.memberNumber = ''
  this.date = [getFirstDayOfCurrentMonth(), new Date()]
  this.token = ''
}
export default {
  name: 'ExpireNotice',
  mixins: [mixin],
  data () {
    return {
      // 分页数据
      currentNo: 1,
      total: 0,
      pageSize: 100,

      query: new Query(),
      tableData: [],
      // 主体数组
      companyList: [],
      dayJs: dayJs,
    }
  },
  async created () {
    api.spotPurchaseSaleInquiry.getToken().then((res) => {
      this.query.token = res
      this.query.memberNumber = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.account
      this.getAllCompany()
      this.fetchGoodsData()
    })
  },
  methods: {
    async fetchGoodsData (page) {
      if (page) {
        this.currentNo = page
      }
      if (!this.query.date.length) {
        this.$message.error('请输入开始结束时间')
        return
      }
      this.query.beginDate = `${dayJs(this.query.date[0]).format('YYYY-MM-DD')} 00:00:00`
      this.query.endDate = `${dayJs(this.query.date[1]).format('YYYY-MM-DD')} 23:59:59`

      let param = Object.assign({}, this.query, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
      })

      let res = await api.spotPurchaseSaleInquiry.getReceiptData(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    async getAllCompany () {
      this.companyList = (await api.spotPurchaseSaleInquiry.getAllCompany(this.query)).data
      // 取数组最后一个为默认主体
      // this.query.companyId = this.companyList[this.companyList.length && this.companyList.length - 1].id
    },
    handleReset () {
      this.query.endDate = ''
      this.query.beginDate = ''
      this.query.companyId = 'hCsAAAAAAYDM567U'
      this.query.date = [getFirstDayOfCurrentMonth(), new Date()]
      this.fetchGoodsData(1)
    },
    // 分页
    changePage (page) {
      this.fetchGoodsData(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  .pagination {
    float: right;
    margin: 20px 0;
  }

</style>
